// import { Navigate } from "react-router-dom";
// import { useAuth } from "./AuthContext";

// function ProtectedRoute({ children, allowedRoles }) {
//   const { token, roleName } = useAuth();

//   if (!token) {
//     return <Navigate to="/" replace />;
//   }

//   if (
//     allowedRoles &&
//     !allowedRoles.includes(roleName)
//   ) {
//     return <Navigate to="/unauthorized" replace />;
//   }

//   return children;
// }

// export default ProtectedRoute;
//import { useAuth } from "./AuthContext";
// import { Navigate } from "react-router-dom";

// const ProtectedRoute = ({ children, pageUrl }) => {
//     const menus = JSON.parse(localStorage.getItem("menus")) || [];

//     const hasPermission = menus.some(
//         m => m.menuUrl?.toLowerCase() === pageUrl.toLowerCase()
//     );

//     return hasPermission ? children : <Navigate to="/unauthorized" replace />;
// };

// export default ProtectedRoute;
// import { Navigate, Outlet, useLocation } from "react-router-dom";

// const ProtectedRoute = ({ children }) => {

//     const location = useLocation(); // ✅ सबसे पहले
//     const currentPath = location.pathname.toLowerCase();

//     const token = localStorage.getItem("token");

//     if (!token) {
//         return <Navigate to="/login" replace />;
//     }

//     const menus = JSON.parse(localStorage.getItem("menus")) || [];

//     const publicPages = ["/dashboard"];

//     if (publicPages.includes(currentPath)) {
//         return children ? children : <Outlet />;
//     }

//     const hasPermission = menus.some(
//         m => m.menuUrl?.toLowerCase() === currentPath
//     );

//     if (!hasPermission) {
//         return <Navigate to="/unauthorized" replace />;
//     }

//     return children ? children : <Outlet />;
// };

// export default ProtectedRoute;



// import { Navigate, Outlet, useLocation } from "react-router-dom";

// const ProtectedRoute = ({ children }) => {

//     const location = useLocation();
//     const currentPath = location.pathname.toLowerCase();

//     const token = localStorage.getItem("token");

//     if (!token) {
//         return <Navigate to="/login" replace />;
//     }

//     const menus = JSON.parse(localStorage.getItem("menus")) || [];

//     // 👇 यह तीनों line यहाँ add करें
//     console.log("Current Path:", currentPath);
//     console.log("Menus:", menus);
//     console.log("LocalStorage:", localStorage.getItem("menus"));

//     const publicPages = ["/"];

//     if (publicPages.includes(currentPath)) {
//         return children ? children : <Outlet />;
//     }

//     const hasPermission = menus.some(
//         m => m.menuUrl?.toLowerCase() === currentPath
//     );

//     if (!hasPermission) {
//         return <Navigate to="/unauthorized" replace />;
//     }

//     return children ? children : <Outlet />;
// };

// export default ProtectedRoute;


import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {

    const location = useLocation();

    const currentPath =
        location.pathname.toLowerCase().replace(/\/$/, "");

    const token = localStorage.getItem("token");

    // ================================
    // LOGIN CHECK
    // ================================

    if (!token) {
        return <Navigate to="/login" replace />;
    }


    // ================================
    // MENUS
    // ================================

    const menus =
        JSON.parse(localStorage.getItem("menus")) || [];


    console.log("Current Path:", currentPath);
    console.log("Menus:", menus);


    // ================================
    // PUBLIC PAGES
    // ================================

    const publicPages = [
        "/",
        "/login"
    ];

    if (publicPages.includes(currentPath)) {
        return children ? children : <Outlet />;
    }


    // ================================
    // MENU PERMISSION CHECK
    // ================================

    const hasPermission = menus.some((m) => {

        const menuUrl =
            m.menuUrl?.toLowerCase().replace(/\/$/, "");

        if (!menuUrl) {
            return false;
        }


        // =================================
        // 1. EXACT MATCH
        // =================================

        if (menuUrl === currentPath) {
            return true;
        }


        // =================================
        // 2. DYNAMIC ROUTE MATCH
        // Example:
        // /edit-community-center/:id
        // /edit-community-center/3
        // =================================

        if (menuUrl.includes(":")) {

            const pattern = menuUrl
                .split("/")
                .map((segment) => {

                    if (segment.startsWith(":")) {
                        return "[^/]+";
                    }

                    return segment;
                })
                .join("/");

            const regex = new RegExp(
                `^${pattern}$`
            );

            if (regex.test(currentPath)) {
                return true;
            }
        }


        // =================================
        // 3. OPTIONAL: CHILD ROUTE
        // Example:
        // /community-center
        // /community-center/list
        // =================================

        if (
            currentPath.startsWith(menuUrl + "/")
        ) {
            return true;
        }


        return false;
    });


    // ================================
    // NO PERMISSION
    // ================================

    if (!hasPermission) {

        console.log(
            "Access denied for:",
            currentPath
        );

        return (
            <Navigate
                to="/unauthorized"
                replace
            />
        );
    }


    // ================================
    // ALLOWED
    // ================================

    return children ? children : <Outlet />;
};

export default ProtectedRoute;